import { ShowPerPage } from "@/stores/showPerPage/showPerPage"
import { HttpRequestAxios } from "../../axios"
interface TypeList {
    order: string,
    page: any,
    showPerPage: any
    name: any
}
export async function GET_LIST_PLACEPHONE(page: any = 1, search?: any) {
    let data: TypeList = {
        order: 'asc',
        page: page,
        name: search,
        showPerPage: ShowPerPage
    }
    return await HttpRequestAxios({ url: '/placePhone/list', data: data })
}
export async function POST_ADD_PLACEPHONE(data: any) {

    return await HttpRequestAxios({ url: '/placePhone/set', data: data })
}
export async function POST_EDIT_PLACEPHONE(data: any) {

    return await HttpRequestAxios({ url: '/placePhone/set', data: data })
}
export async function GET_PLACEPHONE(placePhoneID: number) {
    let data = {
        placePhoneID: placePhoneID
    }
    return await HttpRequestAxios({ url: '/placePhone/get', data: data })
}
export async function POST_REMOVE_PLACEPHONE(placePhoneID: number) {
    let data = {
        placePhoneID: placePhoneID
    }
    return await HttpRequestAxios({ url: '/placePhone/remove', data: data })
}